import React from 'react';

import {PopoverForm} from 'app/general/overlays';

import {CreateUserForm} from './CreateUserForm';

import type {Props as CreateUserFormProps} from './CreateUserForm';
import type {OverlayProps} from 'app/general/overlays';

type Props = CreateUserFormProps & {
  overlayProps: OverlayProps;
};

export const CreateUserPopover = ({
  overlayProps,
  onCreateUser,
  ...other
}: Props) => (
  <PopoverForm overlayProps={overlayProps}>
    {({closeOnSuccess, close}) => (
      <CreateUserForm
        onCreateUser={(user) => closeOnSuccess(onCreateUser(user))}
        onCancel={close}
        {...other}
      />
    )}
  </PopoverForm>
);
